import "../style/index.scss"
import store from "./store"
import { Core } from "@unseenco/taxi"
import { processUrl } from "@unseenco/taxi/src/helpers"
import { qs, Sniffer } from "./utils"
import { Resize, Raf, Scroll, Mouse, Default } from "./core"

import lazySizes from "lazysizes"
lazySizes.cfg.lazyClass = "lazy"
lazySizes.cfg.loadedClass = "loaded"

import PageDefault from "./pages/PageDefault"
import Grid from "./utils/Grid"

export class App {
  constructor() {
    console.log(
      `%c 🚀 Woodarq ✨ \n by Non-Linear Studio \n↳ https://non-linear.studio/ \n\n🛠️ Stack: \n- Astro \n- Sanity CMS \n- GSAP \n- Taxi`,
      "color: #342f2f; font-family: sans-serif; font-size: 14px; line-height: 1.5"
    )
    Object.assign(store.flags, {
      isSmooth: Sniffer.isDesktop,
      isLocked: false,
    })
    store.currentPage = qs("[data-taxi-view]")
    store.contentPage = qs(".app")
    store.currentURL = processUrl(window.location.href)
    this.init()
    this.setListeners()
    this.setGrid()
  }

  setGrid() {
    this.grid = new Grid({
      app: this,
      background: "#ff0000",
      desktop: {
        columns: 18 * 2,
      },
      mobile: {
        columns: 4,
        gutter: 20,
        size: 390,
      },
    })
  }

  setListeners() {
    const { taxi, raf, gl } = store
    taxi.on("NAVIGATE_IN", () => {
      const { currentLocation } = store.taxi
      store.currentURL = currentLocation
      //this.isHomePage(currentLocation.pathname);
      raf.setScroll(0)
    })
    taxi.on("NAVIGATE_END", () => {
      window.jdgm && window.jdgm.loadJS(window.jdgm.CDN_HOST + "loader.js")
    })
    taxi.on("NAVIGATE_OUT", () => {
      // gl.el.onLeave();
    })
  }

  init() {
    const { pathname } = store.currentURL
    const { isSmooth } = store.flags
    if (pathname === "/") store.flags.isHomePage = true
    store.resize = new Resize()
    // webgl.init()
    store.raf = new Raf()
    store.scroll = new Scroll({ isSmooth })
    store.mouse = new Mouse()
    store.taxi = new Core({
      links: "a:not([target]):not([href^=\\#]):not([data-taxi-ignore])",
      renderers: { page: PageDefault },
      transitions: { default: Default },
    })
  }
}

const app = new App()
window.app = app
